module.exports = __webpack_public_path__ + "static/media/buildings1-5x.7172371b.png";